import script from "./ToolEventsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolEventsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ToolEventsPanel.vue?vue&type=style&index=0&id=50746b6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50746b6c"]])

export default __exports__